import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-alert-ribbon',
  templateUrl: './alert-ribbon.component.html',
  styleUrls: ['./alert-ribbon.component.css']
})
export class AlertRibbonComponent implements OnInit {
@Input() alertRibbonData: any;
show = true;
  constructor(private router: Router) { }

  ngOnInit(): void {
    console.log("alertRibbonData in alert-ribbon component = ", this.alertRibbonData);
    
  }

   

  close() {
    this.show = false;
  }

  handleParticipate() {
    // alert("Participate clicked");
   this.router.navigate(['auction/bids']);
  }

}
